import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import {
  RouteMetrics,
  closingPointFor,
  computeRouteMetrics,
} from '../utils/route';

/**
 * Route metrics for the current draft, with the loop-closing leg folded in.
 *
 * Every consumer of route distance goes through this hook so the map, the
 * summary and the profile can never disagree about how long the route is —
 * which is exactly what happened while the closing leg was measured
 * separately from the rest of the path (#404).
 */
export const useRouteMetrics = (): RouteMetrics => {
  const waypoints = useSelector(
    (state: RootState) => state.missionPlanner.draft.waypoints
  );
  const homeBase = useSelector(
    (state: RootState) => state.missionPlanner.draft.homeBase
  );
  const returnToHome = useSelector(
    (state: RootState) => state.missionPlanner.returnToHome
  );

  return useMemo(
    () =>
      computeRouteMetrics(
        waypoints,
        closingPointFor(waypoints, homeBase, returnToHome)
      ),
    [waypoints, homeBase, returnToHome]
  );
};
